import {
  EmptyState,
  FieldText,
  IconButton,
  Select,
  Table,
  Tooltip,
} from '@dixa/lib-shared-habla';
import { ChangeEvent } from 'react';

import { AvailableParameter, Parameter } from '../../cardsTest.types';

import styles from './cardsTestParameterTable.module.scss';

type CardsTestParameterTableProps = {
  parameters: Dictionary<Parameter>;
  availableParameters: AvailableParameter[];
  handleParameterSelect: ({ id }: Parameter, key: string) => void;
  handleParameterDelete: (key: string) => void;
  handleParameterChange: (
    event: ChangeEvent<HTMLInputElement> | undefined,
  ) => void;
};

export const CardsTestParameterTable = ({
  parameters,
  availableParameters,
  handleParameterSelect,
  handleParameterDelete,
  handleParameterChange,
}: CardsTestParameterTableProps): JSX.Element => {
  return (
    <Table
      framed
      wrapperProps={{
        className: styles.table,
      }}
      innerWrapperClassName={styles.tableInnerWrapper}
    >
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Parameter</Table.Th>
          <Table.Th>Replacement</Table.Th>
          <Table.Th />
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>
        {Object.keys(parameters).length > 0 ? (
          Object.keys(parameters).map((key) => {
            return (
              <Table.Tr key={key}>
                <Table.Td className={styles.tableColumn} width="50%">
                  <Select
                    placeholder="Please select a parameter"
                    onSelect={(parameter: Parameter) =>
                      handleParameterSelect(parameter, key)
                    }
                    items={availableParameters}
                  />
                </Table.Td>
                <Table.Td className={styles.tableColumn}>
                  <FieldText
                    placeholder="Please insert your value"
                    input={{
                      name: key,
                      value: parameters[key].value,
                      onChange: handleParameterChange,
                    }}
                  />
                </Table.Td>
                <Table.Td className={styles.tableColumn}>
                  <Tooltip content="Remove" dark>
                    <IconButton
                      variant="tertiary"
                      icon="trash"
                      onClick={() => handleParameterDelete(key)}
                    />
                  </Tooltip>
                </Table.Td>
              </Table.Tr>
            );
          })
        ) : (
          <Table.Tr>
            <Table.Td colSpan={4} padding="400">
              <EmptyState
                title="Nothing to show here"
                description="No custom parameter added"
              />
            </Table.Td>
          </Table.Tr>
        )}
      </Table.Tbody>
    </Table>
  );
};
